export enum AlertType {
  Success,
  Error,
  Info,
  InfoLogo,
  Warning,
}

export enum AlertPosition {
  TopLeft,
  TopRight,
  TopCenter,
  BottomLeft,
  BottomRight,
}